import { applicationRoleSchema } from './application-role.schema';
import { z } from 'zod/v4';

export const userProductRoleV2Schema = z.object({
  id: z.number().min(1),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string().min(1),
  migratedToTrimbleIdentity: z.boolean(),
  lastLogin: z.string().nullable(),
  productRoles: z.array(
    z.object({
      id: z.number(),
      applicationName: z.string(),
      displayName: z.string(),
      roles: z.array(applicationRoleSchema),
    })
  ),
});

export type UserProductRoleV2 = z.infer<typeof userProductRoleV2Schema>;
